import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
// tslint:disable: quotemark

@Component
export default class EventMixin extends Mixins(PrivilegeMixin) {
  public orderDocEventTypeNames = {
    1: 'Email verstuurd',
    2: 'Manueel verstuurd',
    3: 'Vergrendeld',
    4: 'Betaald',
    5: 'Geëxporteerd',
    6: 'Goedgekeurd'
  };

  public orderDocEventTypeColors = {
    1: 'primary',
    2: 'primary',
    3: 'undefined',
    4: 'success',
    5: 'primary',
    6: 'success'
  };

  public eventTypeOptionList = [
    {
      value: null,
      text: 'Toon alle'
    },
    {
      value: 1,
      text: this.orderDocEventTypeNames[1]
    },
    {
      value: 2,
      text: this.orderDocEventTypeNames[2]
    },
    {
      value: 3,
      text: this.orderDocEventTypeNames[3]
    },
    {
      value: 4,
      text: this.orderDocEventTypeNames[4]
    },
    {
      value: 5,
      text: this.orderDocEventTypeNames[5]
    },
    {
      value: 6,
      text: this.orderDocEventTypeNames[6]
    }
  ];
}
